import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";

const storage = getStorage();

export async function uploadApplicantNoteAttachment({
  applicantId,
  file,
}) {
  if (!applicantId || !file) return null;

  const MAX_FILE_SIZE = 10 * 1024 * 1024;

if (file.size > MAX_FILE_SIZE) {
  throw new Error("Attachment must be 10 MB or smaller.");
}

  const extension =
    file.name.split(".").pop() || "bin";

  const filename =
    `${Date.now()}-${Math.random()
      .toString(36)
      .slice(2)}.${extension}`;

  const storageRef = ref(
    storage,
    `applicant-notes/${applicantId}/${filename}`
  );

 console.log("Applicant attachment upload starting", {
  applicantId,
  originalName: file.name,
  storagePath: storageRef.fullPath,
  size: file.size,
  type: file.type,
});

const uploadResult = await uploadBytes(storageRef, file);

console.log("Applicant attachment upload completed", {
  fullPath: uploadResult.ref.fullPath,
});

const downloadUrl = await getDownloadURL(storageRef);

console.log("Applicant attachment download URL created", downloadUrl);

  return {
    name: file.name,
    url: downloadUrl,
    type: file.type,
    size: file.size,
  };
}